export default "__VITE_ASSET__BxXK8op6__"